import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultCreditAlertsUsersDataSelector,
    accountSearchResultCreditAlertsUsersResultSelector,
} from '../../slices/account-search-result-credit-alerts-users.slice';

type Props = {
    accountId: number,
};

export const CreditAlertsUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultCreditAlertsUsersDataSelector);
    const result = useSelector(accountSearchResultCreditAlertsUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/credit-alerts-only"
        />
    );
};
